export enum EvidenceRecurring {
    None = 0,
    OneTime = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
    Quarterly = 5,
    Yearly = 6,
    Continuous = 7
}
